import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { IOffCanvasSearchTrayModalBlockData, offCanvasFields } from './off-canvas-search-tray-modal.component';
import { OpenSearchComponent } from './open-search.component';
export const OPEN_SEARCH_TRAY_MODAL_ID = 'open_search_tray'

@ICmsComponent<OpenSearchWrapperComponent>({
    id: 'open_search_wrapper',
    block: {
        url: 'offCanvas_search_tray'
    },
    onDemandOnly: true,
    name: 'Open Search Wrapper',
    description: 'Open Search Wrapper',
    fields: offCanvasFields
})
@Component({
    selector: 'open-search-wrapper',
    templateUrl: 'open-search-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OpenSearchComponent]
})
export class OpenSearchWrapperComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content: IOffCanvasSearchTrayModalBlockData;

}